import { render, staticRenderFns } from "./mySetMeal.vue?vue&type=template&id=f71402f6&"
import script from "./mySetMeal.vue?vue&type=script&lang=js&"
export * from "./mySetMeal.vue?vue&type=script&lang=js&"
import style0 from "./mySetMeal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports